import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-translation',
  templateUrl: './update-translation.component.html',
  styleUrls: ['./update-translation.component.css']
})
export class UpdateTranslationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/translation/update-translation/update-translation.component.ts